import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Add, Remove } from '@mui/icons-material';
import { FormControl, FormLabel, Grid, IconButton, Slider, TextField } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const LongitudResponderCorreo = () => {
    // Definimos los valores permitidos
    const steps = [240, 480, 720];
    const { promptData, setPromptData } = useActividadesContext();
    const [longitud, setLongitud] = useState(promptData.longitud || 240);

    useEffect(() => {
        setPromptData((prevData) => ({
            ...prevData,
            longitud: longitud,
        }));
    }, [longitud, setPromptData]);

    // La función del Slider ya permite escoger solo los valores definidos en las marcas
    const handleSliderChange = (event, newValue) => {
        setLongitud(newValue);
    };

    // Se valida que el usuario ingrese uno de los valores permitidos
    const handleInputChange = (event) => {
        const newValue = Number(event.target.value);
        if (steps.includes(newValue)) {
            setLongitud(newValue);
        }
    };

    // Se incrementa al siguiente valor permitido si existe
    const handleIncrement = () => {
        const currentIndex = steps.indexOf(longitud);
        if (currentIndex !== -1 && currentIndex < steps.length - 1) {
            setLongitud(steps[currentIndex + 1]);
        }
    };

    // Se decrementa al valor anterior permitido si existe
    const handleDecrement = () => {
        const currentIndex = steps.indexOf(longitud);
        if (currentIndex > 0) {
            setLongitud(steps[currentIndex - 1]);
        }
    };

    return (
        <Grid sx={{ mb: 3, mt: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Longitud
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona la longitud del correo de respuesta
                </FormLabel>
                <Grid container justifyContent="space-between" spacing={2} sx={{width: '700px'}}>
                    <Grid item xs={8}>
                        <Slider
                            value={typeof longitud === 'number' ? longitud : 0}
                            onChange={handleSliderChange}
                            step={null}
                            marks={[
                                
                                { value: 240 },
                                { value: 480 },
                                { value: 720 },

                            ]}
                            min={240}
                            max={720}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} carácteres.`}
                            aria-labelledby="longitud-slider"
                            sx={{
                                color: '#336B87', ml: 5, fontFamily: 'montserrat',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                    fontSize: '0.65rem'
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={3} container spacing={1} >
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={longitud <= steps[0]}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField
                                variant="standard"
                                value={longitud}
                                onChange={handleInputChange}
                                inputProps={{
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>
                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={longitud >= steps[steps.length - 1]}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default LongitudResponderCorreo;
